export const ko = {
    translation: {
        b: {
            cancel: '취소',
            confirm: '확인',
            send: '보내기',
            done: '완료',
            close: '닫기',
            clear: '지우기',
            copy_link: '링크 복사',
            export: '내보내기',
            delete: '삭제',
            delete_confirm: '삭제 확인',
            duplicate: '복제',
            share: '공유',
            sign_in: '로그인',
            sign_up: '회원가입',
            email_address: '이메일 주소',
            yes: '예',
            no: '아니오',
            back: '뒤로',
            upgrade: '업그레이드',
            remove: '제거',
            restore: '복원',
            archive: '보관',
            rename: '이름 변경',
            leave: '나가기',
            import: '가져오기',
            continue: '계속',
            settings: '설정',
            log_out: '로그아웃',
            invite: '초대',
            invited: '초대됨',
        },
        roles: {
            view: '뷰어',
            comment: '코멘터',
            edit: '편집자',
            admin: '관리자',
            owner: '소유자',
            member: '멤버',
            remove: '제거',
            more_roles: '더 많은 역할...',
            change_role: '역할 변경...',
            remove_access: '접근 권한 제거...',
            remove_invite: '초대 제거...',
        },
        db_engine: {
            basic: '기본 SQL',
            general: '일반 SQL',
        },
        socket_status: {
            reconnecting: '재연결 중...',
            offline: '오프라인 상태입니다. 재연결 중...',
        },
        loader: {
            diagram: '다이어그램 불러오는 중...',
        },
        m_languages: {
            title: '언어',
            subtitle: '언어를 선택하세요'
        },
        m_feedback: {
            feature: {
                name: '기능 요청',
                desc: '필요한 기능이 없나요? 알려주세요 — 당신의 아이디어는 소중합니다'
            },
            feedback: {
                name: '피드백 공유',
                desc: '여러분의 생각을 들려주세요'
            },
            support: {
                name: '지원',
                desc: '무언가 제대로 작동하지 않나요? 알려주세요 — 빠르게 해결하겠습니다',
            },
            bug: {
                name: '문제 신고',
                desc: '뭔가 이상한가요? 신고해 주세요 — 신속히 처리하겠습니다',
            },
            integration: {
                name: '연동 요청',
                desc: '여러분의 피드백은 우리에게 매우 중요합니다 — 짧은 메모라도 남겨주세요',
            },
        },
        m_feedback_t: {
            feature: {
                name: '소중한 제안에 감사드립니다!',
                desc: '생각을 공유해 주셔서 진심으로 감사해요 — 더 나은 제품을 만드는 데 큰 도움이 됩니다.'
            },
            feedback: {
                name: '피드백 감사합니다!',
                desc: '생각을 공유해 주셔서 진심으로 감사해요 — 더 나은 제품을 만드는 데 큰 도움이 됩니다.'
            },
            support: {
                name: '문의해 주셔서 감사합니다!',
                desc: '지원팀에 연락해 주셔서 감사합니다 — 요청을 검토한 후 최대한 빨리 답변드리겠습니다.',
            },
            bug: {
                name: '신고해 주셔서 감사합니다!',
                desc: '신고해 주셔서 감사합니다 — 문제를 더 빠르게 해결하고 서비스를 개선하는 데 도움이 됩니다.',
            },
            contact: {
                name: '연락해 주셔서 감사합니다!',
                desc: '메시지를 받았습니다. 최대한 빨리 답변드리겠습니다.',
            },
            invite_people: {
                name: '초대를 보냈습니다!',
                desc: '소식을 전해주셔서 감사합니다 — 새로운 멤버를 맞이하게 되어 기쁩니다.',
            },
            integration: {
                name: '소중한 제안에 감사드립니다!',
                desc: '생각을 공유해 주셔서 진심으로 감사해요 — 더 나은 제품을 만드는 데 큰 도움이 됩니다.',
            },
        },
        m_diagram_details: {
            name_place: '프로젝트 이름 입력',
            desc_place: '프로젝트 설명 입력'
        },
        m_quick_share: {
            title: '빠른 공유',
            subtitle: '(쿼리 기반 링크 공유)'
        },
        m_export_img: {
            title: '이미지 내보내기'
        },
        search_menu: {
            placeholder: '테이블, 열, 타입 검색...',
            hint: '',
            no_results: '결과가 없습니다',
            quick_results: '빠른 검색 결과:',
            untitled: '제목 없음',
            command_tag: '명령어',
            section_tables: '테이블',
            section_columns: '열',
            section_canvas: '캔버스',
            section_export: '내보내기',
            section_preferences: '환경설정',
            section_settings: '설정',
            type_table: '테이블',
            type_note: '노트',
            cmd_new_table: '새 테이블 만들기...',
            cmd_new_note: '새 노트 만들기...',
            cmd_new_line: '새 선 만들기...',
            cmd_new_area: '새 영역 만들기...',
            cmd_export_image: '이미지 내보내기...',
            cmd_export_sql: 'SQL 코드 내보내기...',
            cmd_grid_style: '그리드 레이아웃 변경...',
        },
        canvas_table: {
            more_column: '개의 열 더보기',
            more_columns: '개의 열 더보기',
            tooltip_table: '테이블',
            tooltip_indexes: '인덱스',
            tooltip_enum: 'Enum',
            tooltip_default: '기본값',
            tooltip_generated: '생성됨',
            tooltip_check: '체크',
        },
        m_export_code: {
            title: '코드 {{db_engine}} 내보내기',
            download_file: '파일 다운로드',
            copy_code: '코드 복사'
        },
        m_sign_in_remind: {
            title: 'DB Design을 사용해 주셔서 감사합니다',
            subtitle: '로그인 또는 회원가입하여 테이블 개수 한도를 늘리고, 다이어그램을 저장하고, 더 많은 기능을 이용하세요'
        },
        m_sign_in_restrict: {
            title: '앱에서 더 많은 작업을 하려면 로그인',
            subtitle: '로그인 또는 회원가입하여 테이블 한도를 늘리고, 다이어그램을 저장하고, 더 많은 기능을 이용하세요.'
        },
        m_new_diagram: {
            title: '새 다이어그램',
            subtitle: '데이터베이스 엔진 선택',
            open_diagram: '다이어그램 열기',
            create_diagram: '다이어그램 생성',
            no_workspace: '다이어그램을 만들려면 먼저 워크스페이스를 생성하세요.',
            build_something_new: '새로운 것을 만들어 봅시다',
            create_diagram_section: '다이어그램 생성',
            clone_template_btn: '템플릿 복제',
        },
        m_diagram_name: {
            enter_new_name: '새 다이어그램 이름 입력',
        },
        m_diagram_clone: {
            header: '다이어그램 복제',
            copy_of_title: '{{title}} 사본',
        },
        m_diagram_rename: {
            header: '다이어그램 이름 변경',
        },
        m_template_clone: {
            header: '템플릿으로 다이어그램 만들기',
        },
        m_diagram_delete: {
            header: '다이어그램 삭제',
            desc_prefix: '다음 항목을 삭제합니다: ',
        },
        m_diagram_archive: {
            header: '다이어그램 보관',
            desc_prefix: '다음 항목을 보관합니다: ',
        },
        m_diagram_restore: {
            header: '다이어그램 복원',
            desc_prefix: '다음 항목을 복원합니다: ',
        },
        m_diagram_import: {
            sql_name: 'SQL 코드 가져오기',
            dbml_name: 'DBML 코드 가져오기',
            placeholder: '여러분의 의견을 듣고 싶어요!',
        },
        m_diagram_not_found: {
            header: '다이어그램을 찾을 수 없습니다',
            desc: '찾으시는 다이어그램을 찾을 수 없습니다.',
            back_to_app: '앱으로 돌아가기',
        },
        m_diagram_share: {
            header: '다이어그램 공유 – {{title}}',
            owner_only_invite: '소유자만 새 멤버를 초대할 수 있습니다',
            invited_to_workspace: '워크스페이스에 초대됨',
            you: '나',
            email_placeholder: '이메일 입력',
            email_already_in_list: '이미 목록에 있는 이메일입니다',
            will_be_invited_to_workspace: '워크스페이스에 초대됩니다',
        },
        m_invite_people: {
            header: '워크스페이스에 초대',
        },
        m_invite_revoke: {
            header: '초대 취소',
            desc_prefix: '다음 초대를 취소합니다: ',
            desc_suffix: '이 초대는 더 이상 사용할 수 없게 됩니다.',
        },
        m_member_remove: {
            header: '멤버 제거',
            desc_prefix: '제거하시겠습니까: ',
            desc_suffix: '이 워크스페이스에 대한 접근 권한을 잃게 됩니다.',
        },
        m_template_details: {
            preview: '미리보기',
            use_template: '템플릿 사용',
        },
        m_workspace_create: {
            header: '새 워크스페이스 만들기',
            name_label: '이름',
            setup_config_label: '설정 구성',
            setup_config_value: '빈 워크스페이스',
            template_structure_label: '템플릿 / 구조',
            template_structure_value: '구조 미리 불러오기',
            placeholder: '워크스페이스 이름 입력',
            create_button: '워크스페이스 생성',
            creating: '워크스페이스 생성 중...',
        },
        m_workspace_delete: {
            header: '워크스페이스 삭제',
            desc_prefix: '다음 항목을 영구적으로 삭제합니다: ',
            confirm_prefix: '확인을 위해 ',
            confirm_suffix: '을(를) 입력하세요.',
        },
        m_workspace_leave: {
            header: '워크스페이스 나가기',
            desc_prefix: '다음 워크스페이스에서 나갑니다: ',
            desc_suffix: '다시 참여하려면 재초대가 필요합니다.',
        },
        m_workspace_menu: {
            manage_members: '멤버 관리',
            switch_workspace: '워크스페이스 전환',
            workspaces_label: '워크스페이스',
            create_workspace: '워크스페이스 생성...',
            switching: '전환 중',
        },
        m_profile_menu: {
            profile: '프로필',
            onboarding: '온보딩',
        },
        m_pricing_limit: {
            admin_roles: { title: '협업을 한 단계 업그레이드', description: '업그레이드하여 관리자, 편집자, 코멘터, 뷰어 등 더 많은 공유 역할을 이용해 보세요.' },
            workspaces: { title: '빠르게 성장하고 있네요!', description: '업그레이드하여 프로젝트와 팀을 위한 워크스페이스를 더 많이 만들고 관리하세요.' },
            workspaces_canvas: { title: '워크스페이스 확장하기', description: '업그레이드하여 프로젝트와 팀을 위한 워크스페이스를 더 많이 만들고 관리하세요.' },
            members: { title: '대규모 협업', description: '업그레이드하여 워크스페이스에 더 많은 멤버를 초대하고 더 효과적으로 협업하세요.' },
            diagrams: { title: '빠르게 성장하고 있네요!', description: '업그레이드하여 더 많은 다이어그램을 만들고 자신 있게 프로젝트를 성장시키세요.' },
            tables: { title: '제한 없이 만들기', description: '업그레이드하여 더 많은 테이블을 추가하고 더 크고 상세한 다이어그램을 계속 만들어 보세요.' },
            columns: { title: '제한 없이 만들기', description: '업그레이드하여 더 많은 열을 추가하고 더 크고 상세한 다이어그램을 계속 만들어 보세요.' },
            notes: { title: '제한 없이 만들기', description: '업그레이드하여 더 많은 노트를 추가하고 더 크고 상세한 다이어그램을 계속 만들어 보세요.' },
            areas: { title: '제한 없이 만들기', description: '업그레이드하여 더 많은 영역을 추가하고 더 크고 상세한 다이어그램을 계속 만들어 보세요.' },
            pens: { title: '제한 없이 만들기', description: '업그레이드하여 더 많은 드로잉을 추가하고 더 크고 상세한 다이어그램을 계속 만들어 보세요.' },
            default_title: '협업을 한 단계 업그레이드',
            default_title_canvas: '성능을 한 단계 업그레이드',
        },
        m_pricing_plans: {
            title: '플랜 업그레이드',
            subtitle: '플랜은 언제든지 업그레이드하거나 다운그레이드할 수 있습니다',
            monthly: '월간',
            annually: '연간',
            billed_annually: '연간 결제',
            billed_monthly: '월간 결제',
            free_for_everyone: '누구나 무료',
            current_plan: '현재 플랜',
            will_be_available_soon: '곧 제공 예정',
            price_period_user_month: '/사용자/월',
            plan_free: {
                name: '무료',
                button: '플랜 변경',
                feature_realtime: '실시간 협업',
                feature_members: '워크스페이스당 멤버 4명',
                feature_diagrams: '워크스페이스당 다이어그램 4개',
                feature_tables: '다이어그램당 테이블 40개',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: '무료 플랜의 모든 기능 +',
                feature_members: '멤버 수 무제한',
                feature_diagrams: '다이어그램 수 무제한',
                feature_tables: '테이블 수 무제한',
                feature_history: '버전 기록',
                feature_admin_roles: '관리자 역할',
            },
        },
        sidebar: {
            new: '새로 만들기',
            pinned_diagrams: '고정된 다이어그램',
            pin_hint: '다이어그램을 고정하면 여기에 표시됩니다',
            expand_sidebar: '사이드바 펼치기',
            home_aria: 'DB Design 홈',
            open_menu: '메뉴 열기',
            close_menu: '메뉴 닫기',
            sidebar_menu_aria: '사이드바 메뉴',
            plan_suffix: '플랜',
            diagram_options: '다이어그램 옵션',
            pin: '고정',
            unpin: '고정 해제',
            edit_details: '세부정보 편집',
            see_details: '세부정보 보기',
            invite_people: '초대',
            collapse_sidebar: '사이드바 접기',
            close_sidebar: '사이드바 닫기',
            open_sidebar: '사이드바 열기',
            open_new_tab: '새 탭에서 열기',
        },
        focus_controls: {
            show_top: '상단 컨트롤 표시',
            hide_top: '상단 컨트롤 숨기기',
            show_left: '왼쪽 컨트롤 표시',
            hide_left: '왼쪽 컨트롤 숨기기',
        },
        m_keyboard_shortcuts: {
            title: '키보드 단축키',
            general: {
                title1: '일반',
                title2: '',
                items: {
                    new_diagram: '다이어그램 생성',
                    new_chat: '새 채팅',
                    search: '빠른 작업 / 검색',
                    preferences: '환경설정',
                    settings: '설정',
                    keyboard_shortcuts: '키보드 단축키',
                    toggle_sidebar: '사이드바 전환',
                    toggle_theme: '테마 전환',
                },
            },
            ctrl_left: {
                title1: '컨트롤',
                title2: '(왼쪽)',
                items: {
                    mouse_sel: '마우스 선택 / 핸드 모드',
                    table: '테이블',
                    line: '선',
                    area: '영역',
                    note: '노트',
                    comment: '주석',
                    pen: '펜',
                    undo: '실행 취소',
                    redo: '다시 실행'
                },
            },
            ctrl_top_left: {
                title1: '컨트롤',
                title2: '(왼쪽 상단)',
                items: {
                    export_img: '이미지 내보내기',
                    search: '검색',
                    editor_panel: '에디터 패널',
                    zoom_to_fit: '화면에 맞추기',
                },
            },
            ctrl_bottom_right: {
                title1: '컨트롤',
                title2: '(오른쪽 하단)',
                items: {
                    minimap: '미니맵',
                    full_screen: '전체 화면',
                    zoom_in: '확대',
                    zoom_out: '축소',
                    zoom_100: '줌 100%'
                },
            },
            ctx_tab: {
                title1: '컨텍스트 메뉴',
                title2: '(테이블)',
                items: {
                    dupl_tab: '테이블 복제',
                    del_tab: '테이블 삭제'
                },
            },
            ctx_del_tab: {
                title1: '컨텍스트 메뉴',
                title2: '(테이블 삭제)',
                items: {
                    yes: '예',
                    no: '아니오'
                },
            },
            ctx_tab_col: {
                title1: '컨텍스트 메뉴',
                title2: '(테이블 열)',
                items: {
                    add_col_below: '아래에 열 추가',
                    focus_col_above: '포커스를 위 열로 이동',
                    focus_col_below: '포커스를 아래 열로 이동',
                    move_col_up: '열 위로 이동',
                    move_col_down: '열 아래로 이동',
                    dupl_col: '열 복제',
                    del_col: '열 삭제'
                },
            },
            ctx_line: {
                title1: '컨텍스트 메뉴',
                title2: '(선)',
                items: {
                    del_line: '선 삭제'
                },
            },
            ctx_area: {
                title1: '컨텍스트 메뉴',
                title2: '(영역)',
                items: {
                    dupl_area: '영역 복제',
                    del_area: '영역 삭제'
                },
            },
            ctx_multi: {
                title1: '컨텍스트 메뉴',
                title2: '(다중 선택)',
                items: {
                    select_all: '모든 요소 선택',
                    create_area_for_select_els: '선택한 요소용 영역 생성',
                    dupl_select_els: '선택한 요소 복제',
                    del_select_els: '선택한 요소 삭제'
                },
            },
        },
        t: {
            ctrl_left: {
                mouse_select: '마우스 선택',
                table: '테이블',
                line: '선',
                area: '영역',
                note: '노트',
                comment: '주석',
                pen: '펜',
                undo: '실행 취소',
                redo: '다시 실행'
            },
            ctrl_top_left: {
                home: '홈',
                name: '다이어그램 정보',
                editor: '에디터',
                search: '검색',
                export: '내보내기 옵션',
                view_mode: '보기 모드',
                zoom_to_fit: '화면에 맞추기',
                grid: '그리드 레이아웃',
                history: '기록',
                main_menu: '메인 메뉴',
                new_diagram: '새 다이어그램',
            },
            ctrl_top_right: {
                feature_req: '기능 요청',
                feedback: '피드백 보내기',
                sign_in: '로그인',
                quick_share: '빠른 공유'
            },
            ctrl_bottom_right: {
                full_screen: '전체 화면',
                minimap: '미니맵',
                zoom_out: '축소',
                zoom_100: '줌 100%',
                zoom_in: '확대',
                info: '정보 및 리소스'
            },
            ctx: {
                base: {
                    colors: {
                        default: '기본',
                        blue: '파란색',
                        green: '초록색',
                        red: '빨간색',
                        purple: '보라색',
                        violet: '바이올렛'
                    },
                    borders: {
                        none: '없음',
                        solid: '실선',
                        dashed: '파선',
                        dotted: '점선'
                    },
                    color: '색상',
                    border: '테두리',
                    description: '설명',
                    description_table_place: '테이블 설명',
                    description_column_place: '열 설명',
                    description_line_place: '선 설명',
                    description_note_place: '노트 설명',
                    description_area_place: '영역 설명',
                    description_pen_place: '펜 설명',
                    hide_menu: '메뉴 숨기기',
                    show_menu: '메뉴 표시'
                },
                tab_col: {
                    add_col_below: '아래에 열 추가',
                    add_col_above: '위에 열 추가',
                    key: 'Key',
                    keys: {
                        none: '없음',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: '없음',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: '열 아래로 이동',
                    move_col_up: '열 위로 이동',
                    more_functions: '추가 기능'
                },
                line: {
                    change_connects: '커넥터 변경',
                    connects: {
                        empty: '비어 있음',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: '요소 필터링'
                },
                note: {
                    link_placeholder: '링크 입력',
                    link_apply: '추가',
                    link_remove: '제거',
                    link_edit: '편집',
                    link_needs_selection: '링크를 추가할 텍스트를 선택하세요',
                    bulleted_list: '목록',
                    numbered_list: '번호 매기기 목록',
                    font_style: '글꼴 스타일',
                    alignment: '정렬',
                    align_left: '왼쪽 정렬',
                    align_center: '가운데 정렬',
                    align_right: '오른쪽 정렬',
                    link: '링크',
                    monospace: '고정폭',
                    bold: '굵게',
                    italic: '기울임꼴',
                    underline: '밑줄',
                    strikethrough: '취소선',
                },
                multi: {
                    filter: '선택 필터링',
                    create_area: '영역 만들기'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: '전체',
            keys_only: '키만',
            names_only: '이름만'
        },
        dropdown_ctrl_grid: {
            none: '없음',
            lines: '선',
            dots: '점',
        },
        dropdown_ctrl_export: {
            export_img: '이미지 내보내기',
            export_code: 'SQL 코드 내보내기'
        },
        dropdown_ctrl_settings: {
            back_home: '홈으로 돌아가기',
            sign_in: '로그인',
            preferences: '환경설정',
            new_project: '새 프로젝트',
            import_diagram: '다이어그램 가져오기',
            duplicate_diagram: '다이어그램 복제',
            keyboard_shortcuts: '키보드 단축키',
            languages: '언어',
            view: '보기',
            upgrade_plan: '플랜 업그레이드',
            language: '언어',
            mouse_trackpad: '마우스 또는 트랙패드',
            background_color: '배경색',
            grid_layout: '그리드 레이아웃',
            view_mode: '보기 모드',
            show_align_lines: '정렬선 표시',
            show_members_cursors: '멤버 커서 표시',
            show_comments: '댓글 표시',
            undo_redo_controls: '실행 취소/다시 실행 컨트롤',
            show_scrollbars: '스크롤바 표시',
            opt_auto: '자동',
            opt_trackpad: '트랙패드',
            opt_mouse: '마우스',
            opt_default: '다크(기본값)',
            opt_gray: '그레이',
            opt_blue: '블루',
            opt_purple: '퍼플',
            opt_violet: '바이올렛',
            opt_green: '그린',
            opt_red: '레드',
            opt_yellow: '옐로우',
            opt_dots: '점',
            opt_lines: '선',
            opt_none: '없음',
            opt_full: '전체',
            opt_keys: '키',
            opt_names: '이름',
        },
        dropdown_ctrl_info_resources: {
            feedback: '피드백',
            keyboard_shortcuts: '키보드 단축키',
            languages: '언어',
            homepage: '홈페이지'
        },
        n: {
            default: '로딩 중…',
            file_ready_to_download: '파일을 다운로드할 수 있습니다',
            code_copied: '코드가 복사되었습니다',
            link_copied: '링크가 복사되었습니다',
            username_copied: '사용자 이름이 복사되었습니다',
            email_copied: '이메일이 복사되었습니다',
            please_enter_message: '메시지를 입력해 주세요',
            invalid_email: '이메일 주소가 올바르지 않습니다',
            note_link_unsupported_protocol: '지원되지 않는 링크 형식입니다. https, http, mailto를 사용하세요.',
            something_wrong_contact: '문제가 발생했습니다. 페이지를 새로고침하거나 문의해 주세요.',
            something_wrong: '문제가 발생했습니다. 페이지를 새로고침해 주세요.',
            sending: '전송 중…',
            request_sent: '요청이 전송되었습니다. 감사합니다!',

            please_enter_email: '이메일 주소를 입력해 주세요',
            changing: '변경 중...',
            role_changed: '역할이 변경되었습니다',
            removing: '제거 중...',
            member_removed: '멤버가 제거되었습니다',
            inviting: '초대 중...',
            invite_sent: '초대를 보냈습니다',
            added_to_diagram: '다이어그램에 추가되었습니다',
            invite_removed: '초대가 제거되었습니다',
            role_not_allowed_on_plan: '이 역할은 현재 플랜에서 사용할 수 없습니다. 업그레이드하여 지정하세요.',
            already_diagram_member: '이 사람은 이미 다이어그램에 접근 권한이 있습니다.',
            cannot_invite_to_workspace: '워크스페이스 관리자에게 이 사람을 워크스페이스로 초대하도록 요청하세요.',
            saving: '저장 중...',
            saved: '저장되었습니다',
            diagram_renamed: '다이어그램 이름이 변경되었습니다',
            diagram_updated: '다이어그램이 업데이트되었습니다',
            duplicating: '복제 중...',
            diagram_duplicated: '다이어그램이 복제되었습니다',
            deleting: '삭제 중...',
            diagram_archived: '다이어그램이 보관되었습니다',
            diagram_deleted: '다이어그램이 삭제되었습니다',
            restoring: '복원 중...',
            diagram_restored: '다이어그램이 복원되었습니다',
            diagram_pinned: '다이어그램이 고정되었습니다',
            diagram_unpinned: '다이어그램 고정이 해제되었습니다',
            creating: '생성 중...',
            diagram_created: '다이어그램이 생성되었습니다',
            forbidden: '접근 권한이 없습니다.',
            invite_already_pending: '이 사람에게는 이미 대기 중인 초대가 있습니다.',
            already_member: '이미 워크스페이스 멤버입니다',
            cannot_invite_self: '자기 자신을 초대할 수 없습니다',
            workspace_not_found: '워크스페이스를 찾을 수 없습니다. 페이지를 새로고침한 후 다시 시도하세요.',
            diagram_not_found: '다이어그램을 찾을 수 없습니다.',
            has_diagram_members: '다이어그램에 활동 중인 멤버가 있습니다',
            seat_limit_reached: '플랜의 좌석 한도에 도달했습니다. 업그레이드하여 더 많은 인원을 초대하세요.',
            feature_not_in_plan: '이 기능은 현재 플랜에 포함되어 있지 않습니다.',
            subscription_expired: '구독이 만료되었습니다. 계속 사용하려면 갱신하세요.',
            subscription_inactive: '구독이 비활성 상태입니다. 결제 정보를 업데이트하세요.',
            plan_limit_generic: '현재 플랜에서는 이 작업을 수행할 수 없습니다. 업그레이드하여 계속하세요.',

            // Auth / profile
            session_expired: '세션이 만료되었습니다 — 다시 로그인해 주세요.',
            profile_updated: '프로필이 업데이트되었습니다',
            profile_update_failed: '프로필 업데이트에 실패했습니다.',
            account_delete_failed: '계정 삭제에 실패했습니다.',

            // Preferences
            couldnt_save: '변경 사항을 저장할 수 없습니다',
            try_again: '문제가 발생했습니다. 다시 시도해 주세요.',

            // Workspace
            not_workspace_member: '해당 워크스페이스의 멤버가 아닙니다.',
            workspace_switch_failed: '워크스페이스를 전환할 수 없습니다. 다시 시도해 주세요.',
            workspace_create_failed: '워크스페이스를 생성할 수 없습니다. 다시 시도해 주세요.',
            invalid_workspace_name: '워크스페이스 이름이 올바르지 않습니다',
            workspace_updated: '워크스페이스가 업데이트되었습니다',
            workspace_update_failed: '워크스페이스를 업데이트할 수 없습니다. 다시 시도해 주세요.',
            last_owner_cannot_leave: '당신이 유일한 소유자입니다. 다른 사람을 소유자로 지정하거나 워크스페이스를 삭제한 후 나가세요.',
            workspace_leave_failed: '워크스페이스를 나갈 수 없습니다. 다시 시도해 주세요.',
            workspace_delete_forbidden: '워크스페이스 소유자만 이 워크스페이스를 삭제할 수 있습니다.',
            workspace_has_active_billing: '이 워크스페이스를 삭제하기 전에 구독을 취소하세요.',
            workspace_deleted: '워크스페이스가 삭제되었습니다',
            workspace_delete_failed: '워크스페이스를 삭제할 수 없습니다. 다시 시도해 주세요.',
            member_remove_forbidden: '이 멤버를 제거할 권한이 없습니다.',
            member_remove_failed: '멤버를 제거할 수 없습니다. 다시 시도해 주세요.',
            cannot_remove_self: '자기 자신을 제거하려면 "워크스페이스 나가기"를 사용하세요.',
            cannot_remove_last_owner: '워크스페이스에는 항상 소유자가 있어야 합니다. 먼저 다른 사람을 소유자로 지정하세요.',
            invite_revoke_forbidden: '이 초대를 취소할 권한이 없습니다.',
            invite_revoke_failed: '초대를 취소할 수 없습니다. 다시 시도해 주세요.',
        },
        dashboard: {
            doc_title: '다이어그램',
            filter_all: '전체',
            filter_mydiagrams: '내 다이어그램',
            filter_shared: '공유받은 항목',
            filter_archived: '보관됨',
            empty_all: '"전체 다이어그램"에 다이어그램이 없습니다',
            empty_mydiagrams: '"내 다이어그램"에 다이어그램이 없습니다',
            empty_shared: '"공유받은 항목"에 다이어그램이 없습니다',
            empty_archived: '"보관됨"에 다이어그램이 없습니다',
            example_diagram_badge: '예제 다이어그램',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: '앱으로 돌아가기',
                group_personal: '개인',
                group_organization: '조직',
                billing: '결제',
            },
            profile: {
                member_since: '{{date}}부터 멤버',
                general: '일반',
                email: '이메일',
                full_name: '이름',
                full_name_placeholder: '이름을 입력하세요',
                account_protection: '계정 보호',
                mfa_label: '다단계 인증(MFA)',
                mfa_sub: '계정에 대한 추가 보안 계층 · 곧 제공 예정',
                mfa_enable: 'MFA 활성화',
                mfa_soon_tooltip: '곧 제공될 예정입니다',
                workspace_access: '워크스페이스 액세스',
                leave_workspace: '워크스페이스 나가기',
                leave_workspace_sub: '워크스페이스에서 나를 제거',
                leave_owner_tooltip: '나가기 전에 소유권을 이전하세요',
            },
            workspace: {
                header: '워크스페이스',
                general: '일반',
                name_label: '워크스페이스 이름',
                name_placeholder: '워크스페이스 이름',
                stat_member_singular: '멤버',
                stat_member_plural: '멤버',
                stat_team_singular: '팀',
                stat_team_plural: '팀',
                members_section: '멤버',
                no_members: '멤버 없음',
                count_member_singular: '멤버',
                count_member_plural: '멤버',
                view_members_btn: '멤버 보기',
                danger_zone: '위험 구역',
                delete_workspace: '워크스페이스 삭제',
                delete_workspace_sub: '워크스페이스가 영구적으로 삭제됩니다',
                delete_owner_only_tooltip: '소유자만 워크스페이스를 삭제할 수 있습니다',
                delete_cancel_sub_tooltip: '워크스페이스를 삭제하기 전에 구독을 취소하세요',
            },
            members: {
                header: '멤버',
                col_name: '이름',
                col_email: '이메일',
                col_role: '역할',
                col_joined: '참여일',
                active_members: '활동 중인 멤버',
                invited_section: '초대됨',
                no_members: '아직 멤버가 없습니다.',
                options_aria: '옵션',
                leave_workspace_item: '워크스페이스 나가기...',
                remove_member_item: '멤버 제거...',
                remove_owner_only_tooltip: '소유자만 멤버를 제거할 수 있습니다',
                remove_owner_row_tooltip: '소유자는 워크스페이스에서 제거할 수 없습니다',
                remove_invite_item: '초대 제거...',
                role_invited_suffix: '{{role}} (초대됨)',
            },
            preferences: {
                section_general: '일반',
                section_diagram_defaults: '다이어그램 설정',
                section_diagram_views: '다이어그램 보기',
                section_notifications: '알림',
                theme_label: '인터페이스 테마',
                theme_sub: '인터페이스 색상 구성표를 선택하세요',
                theme_dark: '다크',
                theme_light: '라이트',
                theme_system: '시스템',
                language_sub: '인터페이스 언어를 선택하세요',
                timezone_label: '시간대',
                timezone_sub: '시간대를 선택하세요',
                timezone_options: {
                    honolulu: 'GMT-10:00 — 하와이',
                    anchorage: 'GMT-09:00 — 알래스카',
                    los_angeles: 'GMT-08:00 — 태평양 표준시',
                    denver: 'GMT-07:00 — 산악 표준시',
                    chicago: 'GMT-06:00 — 중부 표준시',
                    new_york: 'GMT-05:00 — 동부 표준시',
                    caracas: 'GMT-04:00 — 카라카스',
                    sao_paulo: 'GMT-03:00 — 상파울루',
                    azores: 'GMT-01:00 — 아조레스',
                    london: 'GMT+00:00 — 런던',
                    paris: 'GMT+01:00 — 파리, 베를린',
                    kyiv: 'GMT+02:00 — 키이우, 아테네',
                    istanbul: 'GMT+03:00 — 이스탄불',
                    dubai: 'GMT+04:00 — 두바이',
                    karachi: 'GMT+05:00 — 카라치',
                    kolkata: 'GMT+05:30 — 인도',
                    dhaka: 'GMT+06:00 — 다카',
                    bangkok: 'GMT+07:00 — 방콕, 자카르타',
                    shanghai: 'GMT+08:00 — 베이징, 싱가포르',
                    tokyo: 'GMT+09:00 — 도쿄, 서울',
                    sydney: 'GMT+10:00 — 시드니',
                    auckland: 'GMT+12:00 — 오클랜드',
                },
                input_mode_sub: '캔버스 탐색 컨트롤을 선택하세요',
                background_sub: '캔버스의 배경색을 선택하세요',
                grid_sub: '캔버스 격자 레이아웃을 선택하세요',
                show_align_lines_sub: '개체를 정렬할 때 선 표시',
                show_cursors_sub: '다른 협업자의 커서 표시',
                show_comments_sub: '캔버스에 댓글 표시',
                show_scrollbars_sub: '캔버스 탐색 중 스크롤바 표시',
                show_undo_redo_label: '실행 취소/다시 실행 컨트롤 표시',
                show_undo_redo_sub: '변경 사항을 취소하거나 다시 실행하는 컨트롤 표시',
                notif_shared_label: '나와 공유된 다이어그램',
                notif_shared_sub: '누군가 나와 다이어그램을 공유할 때',
                notif_mentions_label: '댓글에서의 멘션',
                notif_mentions_sub: '누군가 댓글에서 나를 @멘션할 때',
                notif_updates_label: '제품 업데이트',
                notif_updates_sub: '새로운 기능 및 개선 사항에 대한 월간 업데이트',
                show: '표시',
                hide: '숨김',
                on: '켜짐',
                off: '꺼짐',
            },
            billing: {
                header: '결제',
                plan_free: '무료 플랜',
                status_current: '현재',
                no_renewal_needed: '갱신이 필요하지 않습니다',
                payment_header: '결제',
                no_payments: '결제 내역 없음',
                invoices_header: '청구서',
                no_invoices: '청구서 없음',
            },
            usage: {
                doc_title: '사용량',
                overview_title: '개요',
                resource_limits_title: '리소스 한도',
                label_diagrams: '다이어그램',
                label_tables: '테이블',
                label_areas: '영역',
                label_notes: '스티키 노트',
                label_members: '멤버',
                label_tables_per_diagram: '테이블 / 다이어그램',
                label_areas_per_diagram: '영역 / 다이어그램',
                label_notes_per_diagram: '노트 / 다이어그램',
                need_more_title: '더 필요하신가요?',
                need_more_free: '더 많은 다이어그램, 버전 기록, 우선 지원을 원하시면 Basic으로 업그레이드하세요.',
                need_more_paid: '무제한 다이어그램, 좌석, 고급 기능을 원하시면 Professional로 업그레이드하세요.',
            },
        },
        pages: {
            not_found: {
                page_not_found: '페이지를 찾을 수 없습니다',
                dont_have_access_to_diagram: '이 다이어그램에 대한 접근 권한이 없거나 더 이상 존재하지 않습니다.',
                back_home: '홈으로 돌아가기'
            },
            error: {
                title: '오류',
                link_is_invalid: '이 링크가 유효하지 않거나 잘못 입력되었습니다.',
                something_wrong: '문제가 발생했습니다.',
                back_home: '홈으로 돌아가기',
                please_try_later: '나중에 다시 시도해 주세요',
            },
            billing_success: {
                doc_title: '플랜이 업그레이드되었습니다',
                heading: '결제가 완료되었습니다',
                subtitle: '플랜이 성공적으로 업그레이드되었습니다.',
                cta: '디자인 시작하기',
            },
            email_verified: {
                doc_title: '이메일 인증 완료',
            },
            forgot_password: {
                doc_title: '비밀번호 찾기',
            },
            password_updated: {
                doc_title: '비밀번호가 변경되었습니다',
            },
            reset_password: {
                doc_title: '비밀번호 재설정',
            },
            check_email: {
                doc_title: '이메일을 확인하세요',
            },
            sign_in: {
                doc_title: '{{product}}에 로그인',
            },
            sign_up: {
                doc_title: '{{product}}에 가입',
            },
        },
    },
};

export const koMeta = {
    lang_origin: '한국어',
    lang_eng: 'Korean',
    lang_code: 'ko',
};
